define('SageDotCom/Components/StickyDynamicMenu',[
    "jquery",
    "SageDotCom/Utility/sanitizer",
    "eventManager"
], function ($, sanitizer, eventManager) {
    function StickyDynamicMenu(scope, showMoreItemsText, hideMoreItemsText) {

        Object.defineProperty(this, "$scope", {
            enumerable: true,
            value: $(scope)
        });

        var resizeTimerAnchor = null;
        var resizeTimer = null;
        var scrollTimer = null;
        var buttonMoved = false;
        var chevronEl = scope.querySelector(".navbar-brand .icon-caret");
        var navEl = scope.querySelector(".navbar-collapse");
        var navWrapper = scope.querySelector(".score-nav-wrapper");
        var links = navEl.querySelector(".links");
        var overflowMenu = navEl.querySelector(".overflow-menu");
        var hiddenLinks = overflowMenu.querySelector(".hidden-links");
        var navbarBrand = scope.querySelector(".navbar-brand");
        var isAnchorMenu = scope.classList.contains("center");
        var isSpotlightMenu = scope.classList.contains("spotlight");
        var persistenStickyNav = scope.classList.contains("persistent-sticky-nav");
        var skinnyBanner = document.querySelector(".skinny-banner");
        var scoreAnchorpoint = document.querySelector(".score-anchorpoint");

        addAriaAttributes(links);
        if (persistenStickyNav == false) {
            getLinksWidth();
        }

        setMenuColumns();
        if (isAnchorMenu == false && persistenStickyNav == false) {
            checkMenuButtonsMobile();
            resizeNavHeaderComponent();
        }

        calcStickyNavPosition();

        //so cant be tabbed on mobile
        $(".sticky-nav .links .score-megamenu-dropdown .dropdown-toggle").attr("tabindex","-1");

        //for overflow menu open/close logic + keyboard logic
        overflowMenu.addEventListener("mouseenter", function() { 
            this.classList.add("open");
            var showMoreButton = overflowMenu.querySelector(".show-more-button");
            showMoreButton.setAttribute("aria-expanded", "true");
            var showMoreAria = overflowMenu.querySelector(".show-more-text.sr-only");
            showMoreAria.textContent = hideMoreItemsText;
            if (isAnchorMenu == true) {
                var el = hiddenLinks.getBoundingClientRect();
                if (0 > el.x) {
                    hiddenLinks.style.right = "0";
                }
            }
        });
        overflowMenu.addEventListener("mouseleave", function() { 
            this.classList.remove("open");
            var showMoreButton = overflowMenu.querySelector(".show-more-button");
            showMoreButton.setAttribute("aria-expanded", "false");
            var showMoreAria = overflowMenu.querySelector(".show-more-text.sr-only");
            showMoreAria.textContent = showMoreItemsText;
            if (isAnchorMenu == true) {
                hiddenLinks.style = "";
            }
        });

        // now overflow is a button we can use click event with bubbling rather than keyup
        overflowMenu.addEventListener("click", function (e) {
            var showMoreButton = overflowMenu.querySelector(".show-more-button");
            var showMoreAria = overflowMenu.querySelector(".show-more-text.sr-only");
            if (this.classList.contains("open") && e.target.classList.contains("show-more-button")) {
                this.classList.remove("open");
                showMoreButton.setAttribute("aria-expanded", "false");
                showMoreAria.textContent = showMoreItemsText;
            } else {
                this.classList.add("open");
                showMoreButton.setAttribute("aria-expanded", "true");
                showMoreAria.textContent = hideMoreItemsText;
                if (isAnchorMenu == true) {
                    var el = hiddenLinks.getBoundingClientRect();
                    if (0 > el.x) {
                        hiddenLinks.style.right = "0";
                    }
                }
                this.addEventListener("focusout", function () {
                    var el = $(this);
                    setTimeout(function () {
                        var hasFocus = el.find(":focus").length > 0;
                        if (!hasFocus) {
                            el.removeClass("open");
                            var showMoreButton = overflowMenu.querySelector(".show-more-button");
                            showMoreButton.setAttribute("aria-expanded", "false");
                            var showMoreAria = overflowMenu.querySelector(".show-more-text.sr-only");
                            showMoreAria.textContent = showMoreItemsText;
                            if (isAnchorMenu == true) {
                                hiddenLinks.style = "";
                            }
                        }
                    }, 10);
                });
            }
        });

        if (isAnchorMenu == false) {
            $(".sticky-nav .links .score-megamenu-dropdown").on("mouseenter", function() { 
                if (this.parentElement.classList.contains("hidden-links")) {
                    return;
                }
                //check this
                if (scope.classList.contains("collapsed")) {
                    return;
                }
                var dropdownLink = this.firstElementChild;
                dropdownLink.setAttribute("aria-expanded","true");

                $(this).addClass("open");
            });

            $(".sticky-nav .links > .score-megamenu-dropdown").on("keyup", function(e) { 
            var keyCode = e.keyCode || e.which; 

            if (keyCode == 13 || keyCode == 32) {
                var self = this;
                this.addEventListener("focusout", function() {
                    var el = $(this);
                        setTimeout(function() {
                        var hasFocus = el.find(":focus").length > 0;
                        if (!hasFocus) {
                            el.removeClass("open");
                            var dropdownLink = self.firstElementChild;
                            dropdownLink.setAttribute("aria-expanded","false");
                        }
                    }, 10);
                });
            }
            });
        }
        //so it doesnt close the dropdown menu when hovering on an element and leaving
        $( ".links .score-megamenu-dropdown" ).on( "mouseleave", function() {
            if (document.body.classList.contains("sticky-open")) {
                return;
            } else if ($(this).parent().hasClass("hidden-links")) {
                return;
            }
            if (scope.classList.contains("collapsed")) {
                return;
            }
            var dropdownLink = this.firstElementChild;
            dropdownLink.setAttribute("aria-expanded","false");

            $(this).removeClass("open");
        });
        var currentWidth = $(window).width();
        $(window).on("resize orientationchange", function () {
            if (resizeTimer) {
                clearTimeout(resizeTimer);
            }
            if (resizeTimerAnchor) {
                clearTimeout(resizeTimerAnchor);
            }
            if (persistenStickyNav == true) {
                return;
            }
            //normal sticky nav
            if (isAnchorMenu == false) {
                var titleContainer = navbarBrand.querySelector(".titleContainer");
                titleContainer.style = "";

                resizeTimer = setTimeout(function () {
                    var newWidth = $(window).width();
                    var links = navEl.querySelector(".links");
                   
                        //if mobile view put everything into main links menu (if it was in overflow menu)
                        if (chevronEl && chevronEl.offsetWidth || chevronEl.offsetHeight || chevronEl.getClientRects().length) {
                            var childElements = hiddenLinks.children;

                            if (hiddenLinks.children.length != 0) {

                                //move to the nav menu
                                var childElements = hiddenLinks.children;
                                var childElementsLength = childElements.length;
                                for (var i = 0; childElementsLength > i; i++) {
                                    $(links).append(childElements[0]);
                                }
                            }
                        } else {
                            var titleContainer = navbarBrand.querySelector(".titleContainer");
                            titleContainer.style = "";
                            checkMenuDimensions();
                        }
                    
                   
                    checkMenuButtonsMobile();
                    calcStickyNavPosition();
                    if (newWidth !== currentWidth) {
                        resizeNavHeaderComponent();
                    }
                    for(var i=0; links.children.length > i;i++) {
                        links.children[i].classList.remove("open");
                    }
                    if (newWidth !== currentWidth) {
                        currentWidth = newWidth;
                    }
                },300);
                //close open menus
                links.classList.remove("open");
                chevronEl.setAttribute("aria-expanded","false");
                if (chevronEl) {
                    chevronEl.classList.remove("up");
                }
                document.body.classList.remove("sticky-open");
                links.style = "";
            } else {
                //anchor sticky nav
                resizeTimerAnchor = setTimeout(function(){
                    anchorMenuCheck();
                },300);
            }
        });

        if (skinnyBanner || scoreAnchorpoint) {
            document.addEventListener("scroll", function() { 
                if (scrollTimer) {
                    clearTimeout(scrollTimer);
                }
                scrollTimer = setTimeout(function(){
                    $(".score-anchorpoint").each(function(anchor) {
                        el = this;
                        if (el) {
                            var idName = "#" + el.id;
                            if (idName == "#") {
                                console.warn("Anchor tag missing ID");
                                return;
                            }
                            if (isElementPartiallyInViewport($(idName))) {
                                //remove all other anchors which are bold
                                $(".score-anchorpoint").each(function(anchor) {
                                    element = this;
                                    if (element) {
                                        var idNameToRemove = "#" + element.id;
                                        if (idNameToRemove == "#") {
                                            return;
                                        }
                                        $('.sticky-nav a[href="' + idNameToRemove + '"]').parent().removeClass("active");
                                    }
                                });
                                //make current section anchor bold
                                $('.sticky-nav a[href="' + idName + '"]').parent().addClass("active");
                            }
                        }
                    });
                },150);
            });
        }

        //navbar-brand - when clicking to open menu on mobile
        if (navbarBrand && !isSpotlightMenu) {
            navbarBrand.addEventListener("click", function (e) {
                if (chevronEl && chevronEl.offsetWidth || chevronEl.offsetHeight || chevronEl.getClientRects().length) {
                    links.classList.toggle("open");
                    chevronEl.classList.toggle("up");
                    document.body.classList.toggle("sticky-open");

                    //when sticky nav menu opened on mobile calculate its height
                    if (links.classList.contains("open")) {
                        var scrollToTop = $(window).scrollTop();
                        var header = document.querySelector("header");
                        var skinnyBannerHeight = skinnyBanner ? skinnyBanner.clientHeight : 0;
                        var headerHeight = header ? header.clientHeight : 0;
                        var stickyNavHeight = document.querySelector(".sticky-nav").clientHeight;
                        var skinnyBannerAndHeaderHeight = skinnyBannerHeight + headerHeight;
             
                        //calculates how much header + skinny banner height is visible after scroll
                        if (scrollToTop != 0) {
                            if ($(skinnyBanner).css("position") != "sticky") {
                                if (scrollToTop >= skinnyBannerAndHeaderHeight) {
                                    skinnyBannerAndHeaderHeight = 0;
                                } else {
                                    skinnyBannerAndHeaderHeight = skinnyBannerAndHeaderHeight - scrollToTop;
                                }
                            } else {
                                if (scrollToTop >= headerHeight) {
                                    skinnyBannerAndHeaderHeight = skinnyBannerAndHeaderHeight - headerHeight;
                                } else {
                                    skinnyBannerAndHeaderHeight = skinnyBannerAndHeaderHeight - scrollToTop;
                                }
                            }
                        }
     
                        skinnyBannerAndHeaderHeight = skinnyBannerAndHeaderHeight < 0 ? 0 : skinnyBannerAndHeaderHeight; //incase its negative for some reason

                        var elHeight = window.innerHeight - stickyNavHeight - skinnyBannerAndHeaderHeight; // set height of the opened menu
                        links.style.height = elHeight + "px";
                        links.style.top = stickyNavHeight + "px";
                        chevronEl.setAttribute("aria-expanded","true");
                    } else {
                        chevronEl.setAttribute("aria-expanded","false");
                        links.style = "";
                    }
                }
            });
        }

        const scrollToHash = function (hash) {
            if (sanitizer.containsHTML(hash)) {
                if (window.enableLogging) {
                    console.error("SAGE DEBUG: Hash contains html, ignoring");
                }
                return false;
            }

            if ($(hash).offset() == null) {
                return false;
            }

            $("html, body").stop().animate({
                scrollTop: $(hash).offset().top - 60
            }, 750, function () {
                location.hash = hash ? hash : "";
            });
        }

        //If link is to the current page, e.g with a hash and/or querystring, don't reload the page
        $('.sticky-nav a[href]:not([href^="#gate"], [href^="#"], .dropdown-toggle, .show-more-button, .score-megamenu-dropdown a[data-toggle="dropdown"], .score-megamenu-dropdown button[data-toggle="dropdown"])').on("click", function (e) {

            const linkHref = $(this).attr("href");
            let url;

            try {
                url = new URL(linkHref, window.location.origin);
            } catch (ex) {
                //Not in the current domain, or a different error, so redirect
                return true;
            }

            let testPath = url.pathname;
            if (!testPath.endsWith('/')) {
                testPath = testPath + "/";
            }

            let windowTestPath = window.location.pathname;
            if (!windowTestPath.endsWith('/')) {
                windowTestPath = windowTestPath + "/";
            }

            if (testPath !== windowTestPath) {
                //different page, redirect
                return true;
            }

            //if has a hash, go through the hash logic
            scrollToHash(url.hash);

            //if has a query string raise an event
            eventManager.trigger("query-string-change", url.search);

            return false;
        });

        //scroll on anchor click
        $('.sticky-nav a[href^="#"]:not([href^="#gate"], .dropdown-toggle, .show-more-button, .score-megamenu-dropdown a[data-toggle="dropdown"], .score-megamenu-dropdown button[data-toggle="dropdown"])').on("click", function(e) {
            e.preventDefault();

            //when mobile menu and they click an anchor link
            links.classList.remove("open");
            if (chevronEl) {
                chevronEl.classList.remove("up");
            }
            document.body.classList.remove("sticky-open");

            var target = $(this);
            if (!(target && target[0].hasAttribute("href"))) return false;
            
            scrollToHash(target.attr("href"));
            
            return false;
        });

        //back button for success stories
        $(".customer-success-filter-child-button").on("click", function () {
            var currentUrl = document.location.href;
            var queryString = document.location.search;

            //Preventing XSS attack
            if (!sanitizer.containsHTML(currentUrl) && !sanitizer.containsHTML(queryString)) {
                currentUrl = currentUrl.replace(queryString, "");

                if (currentUrl.charAt(currentUrl.length - 1) === "/") {
                    currentUrl = currentUrl.slice(0, currentUrl.length - 1);
                }
                var lastIndex = currentUrl.lastIndexOf("/");
                if (lastIndex > 0) {
                    currentUrl = currentUrl.slice(0, lastIndex);
                }

                //only add the parameter if it doesn't already exist
                if (queryString.lastIndexOf("openFilter=true") <= 0) {
                    if (queryString === "") {
                        queryString = "?";
                    } else {
                        queryString += "&";
                    }
                    queryString += "openFilter=true";
                }
                currentUrl = currentUrl + "/" + queryString;
                //remove any single character bucket folders
                currentUrl = currentUrl.replace(/\/[a-zA-Z0-9]\//g, "/");
                currentUrl = sanitizer.stripHtml(decodeURIComponent(currentUrl)); // replace any html
                document.location.href = currentUrl;
            }
        });

        function calcStickyNavPosition() {
            var skinnyBannerHeight = skinnyBanner ? skinnyBanner.clientHeight : 0;
            if ($(skinnyBanner).css("position") == "sticky") {
                scope.style.top = skinnyBannerHeight + "px";
            } else {
                scope.style = "";
            }
        }

        function addAriaAttributes(links) {
            var linksChildren = links.children;
            for(var i = 0; linksChildren.length > i;i++) {
                if (linksChildren[i].classList.contains("score-megamenu-dropdown")) {
                    var dropdownLink = linksChildren[i].firstElementChild;
                    dropdownLink.setAttribute("aria-expanded","false");
                }
            }
        }

        //adds data attribute with width of each link - so that on resize we can calculate where they go
        function getLinksWidth() {
            links.style.display = "flex";
            var linksChildren = links.children;

            //get item width -- used for calculating items in the menu
            for (var i = 0; linksChildren.length > i; i++) {
                linksChildren[i].setAttribute("data-nav-width",linksChildren[i].clientWidth);
            }
            links.style = "";
            if (isAnchorMenu == false) {
                mobileMenuCheck();
            } else {
                anchorMenuCheck();
            }
        }

        //moves a button from main nav bar into the dropdown on mobile
        function checkMenuButtonsMobile() {
            var navElements = navEl.querySelectorAll(".navbar-nav");
            var btnWrapper = navElements[navElements.length - 1];
            //move first button into dropdownmenu
            if (buttonMoved == false && document.body.clientWidth < 768) {
                var allButtons = [];
                for (var i = 0; btnWrapper.children.length > i;i++) {
                    var isBtn = btnWrapper.children[i].querySelector(".score-button");
                    if(isBtn) {
                        btnWrapper.children[i].setAttribute("data-location","main-nav");
                        allButtons.push(btnWrapper.children[i]);
                    }
                }
                if (allButtons.length > 1) {
                    $(links).prepend(allButtons[0]);
                    buttonMoved = true;
                }
            } else if (buttonMoved == true && document.body.clientWidth >= 768 ) {
                var navBtn = links.querySelector('li[data-location="main-nav"]');
                if (navBtn) {
                    var navElements = navEl.querySelectorAll(".navbar-nav");
                    var btnWrapper = navElements[navElements.length - 1];
                    
                    if ($(".phone-number-wrapper").length == 0) {
                        $(btnWrapper).prepend(navBtn);
                    } else {
                        $(navBtn).insertAfter($(".phone-number-wrapper"));
                    }
                    buttonMoved = false;
                }
            }


        }

        function setMenuColumns() {
            var dropdowns = $(scope).find(".score-megamenu-dropdown");
            if (dropdowns != null)
            {
                $(dropdowns).each(function() {
                    var dropdownItem = $(this);
                    var dropdownItemContentDiv = $(dropdownItem).find(".score-megamenu-content");
                    var items = $(dropdownItem).find(".score-menu-list-item");
                    var divContentChildren = $(dropdownItemContentDiv).find(".score-menu-list");
                    var itemsPerCol = [];
    
                    if (items != null && items.length >= 9 && $(divContentChildren).length == 1)
                    {
                        var totalColumns = Math.floor(items.length / 9) + 1;

                        for (var x = 0; (totalColumns - 1) > x; x++) {
                            var colNumber = x + 2;
                            var col = $(divContentChildren).first().clone().empty();
                            $(col).attr("id", $(col).attr("id") + "-col-"+ colNumber);
                            $(dropdownItemContentDiv).append(col);
                        }

                        var minItemsPerCol = Math.floor(items.length / totalColumns);
                        var difference = items.length - (minItemsPerCol * totalColumns);
                        
                        for (var i = 0; i < totalColumns; i++) {
                            itemsPerCol[i] = i < difference ? minItemsPerCol + 1 : minItemsPerCol;
                        }
    
                        //first col already populated start at 1
                        for (var i = 1; i < totalColumns; i++) {
                            var startingIndex = i == 1 ? itemsPerCol[0] : (itemsPerCol[0] + itemsPerCol[1]);
                            //how many items to add
                            for (var x = 0; x < itemsPerCol[i]; x++)
                            {
                                var colToAppend = $(dropdownItemContentDiv).children(".score-menu-list")[i];
                                $(colToAppend).append(items[startingIndex]);
                                startingIndex++;
                            }
                        }
                    }
                });
            }
        }
        
        //checks for mobile menu
        function mobileMenuCheck() {
            if (chevronEl && chevronEl.offsetWidth || chevronEl.offsetHeight || chevronEl.getClientRects().length) {
                var childElements = hiddenLinks.children;

                if (hiddenLinks.children.length != 0) {
                    var links = navEl.querySelector(".links");
                    //move to the main nav menu
                    var childElements = hiddenLinks.children;
                    var childElementsLength = childElements.length;
                    for(var i = 0; childElementsLength > i;i++) {
                        $(links).append(childElements[0]);
                    }
                }
            } else {
                checkMenuDimensions();
            }
        }

        function anchorMenuCheck() {
            var navEl = scope.querySelector(".score-nav-wrapper");
            var navElWidth = navEl.offsetWidth;
            var menuItems = navEl.querySelector(".navbar-collapse");
            var menuLinks = navEl.querySelector(".links");
            var hiddenLinks = navEl.querySelector(".hidden-links");
            var overflowMenu = navEl.querySelector(".overflow-menu");
            var menuItemsWidth = menuItems.offsetWidth;
            
            //remove items into overflow menu
            if ((menuItemsWidth + 40) > navElWidth) {
                var index = 0;
                while ((menuItemsWidth + 40) > navElWidth) {
                    $(hiddenLinks).prepend(menuLinks.lastElementChild);
                    overflowMenu.classList.remove("hide");
                    menuItemsWidth = menuItems.offsetWidth;
                    index++;
                    if (index == 10)
                        break;
                }

            } else {
                if (hiddenLinks.children.length > 0) {
                    var index = 0;
                    var firstItem = hiddenLinks.firstElementChild;
                    var firstItemWidth = firstItem.getAttribute("data-nav-width");
                    
                    while (navElWidth > (menuItemsWidth + 40 + Number(firstItemWidth))) {
                        $(menuLinks).append(firstItem);
                        menuItemsWidth = menuItems.offsetWidth;
                        if (hiddenLinks.children.length == 0) {
                            overflowMenu.classList.add("hide");
                            break;
                        }
                        firstItem = hiddenLinks.firstElementChild;
                        firstItemWidth = firstItem.getAttribute("data-nav-width");
                        index++;
                        if (index == 10)
                            break;
                    }
                }
            }
        }

        function calculateMenuWidth() {
            var navElChildren = navEl.children;
            var childrenItemLength = 0;
            for(var i = 0; navElChildren.length > i; i++) {
                if (navElChildren[i].classList.contains("links")) {
                    var linkElChildren = navElChildren[i].children;
                    for(var y = 0; linkElChildren.length > y;y++) {
                        childrenItemLength += linkElChildren[y].clientWidth;
                    }
                } else if (navElChildren[i].classList.contains("overflow-menu")) {
                    childrenItemLength += navElChildren[i].clientWidth;
                } else {
                    childrenItemLength += navElChildren[i].clientWidth;
                }
            }
            return childrenItemLength;
        }

        //function that moves the menu items to overflow menu and back to main nav
        function checkMenuDimensions() {
        
            var navElWidth = navEl.clientWidth;
            var navElChildren = navEl.children;
            var navElChildrenWidth = 0;
            var menuWidthUsed = false;

            //calculates menu width (items in it)
            for(var i = 0; navElChildren.length > i; i++) {
                if (navElChildren[i].classList.contains("links")) {
                    var linkElChildren = navElChildren[i].children;
                    for(var y = 0; linkElChildren.length > y;y++) {
                        navElChildrenWidth += linkElChildren[y].clientWidth;
                    }
                } else if (navElChildren[i].classList.contains("overflow-menu")) {
                    if (navElChildren[i].clientWidth != 0) {
                        menuWidthUsed = true; 
                        navElChildrenWidth += navElChildren[i].clientWidth;
                    }
                } else {
                    navElChildrenWidth += navElChildren[i].clientWidth;
                }
            }

            //check if items need to be removed or added to the menu
            if ((navElWidth - navElChildrenWidth) > 104) {
                if (hiddenLinks.children.length == 0) {
                    if (overflowMenu && overflowMenu.classList.contains("hide") == false) 
                        overflowMenu.classList.add("hide");
                } else {
                    //remove items from overflow menu
                    var index = 0;
                    var firstItem = hiddenLinks.firstElementChild;
                    var firstItemWidth = firstItem.getAttribute("data-nav-width");
                    while(((navElWidth - navElChildrenWidth) > (104 + Number(firstItemWidth)))) {
                        $(links).append(firstItem);
                        navElChildrenWidth = navElChildrenWidth + Number(firstItemWidth);
                        //check next item
                        if (hiddenLinks.children.length == 0) {
                            overflowMenu.classList.add("hide");
                            break;
                        }
                        firstItem = hiddenLinks.firstElementChild;
                        if (!firstItem || index == 10) { 
                            break;
                        }
                        firstItemWidth = firstItem.getAttribute("data-nav-width");
                        index++;
                    }
                }
            } else {
                //put items in overflow menu
                var index = 0;
                var lastChild = links.lastElementChild;
                while ((navElWidth - calculateMenuWidth()) < 104) {
                    $(hiddenLinks).prepend(lastChild);
                    overflowMenu.classList.remove("hide");
    
                    if (menuWidthUsed == false) { 
                        navElChildrenWidth = navElChildrenWidth + overflowMenu.clientWidth;
                        menuWidthUsed = true;
                    }
    
                    lastChild = links.lastElementChild;
                    if (!lastChild || index == 10) {
                        break;
                    }
                    index++;
                }
            }
        }

        function isElementPartiallyInViewport(el)
        {
            // Special bonus for those using jQuery
            if (typeof jQuery !== "undefined" && el instanceof jQuery)
                el = el[0];

            var rect = el.getBoundingClientRect();
            var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
            var windowWidth = (window.innerWidth || document.documentElement.clientWidth);

            var vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
            var horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

            return (vertInView && horInView);
        }

        function resizeNavHeaderComponent() {
            if (document.body.clientWidth < 1080) {
                var maxWidth = $(navWrapper).width();
                var maxWidthVal = maxWidth * 0.35; 
                if (document.body.clientWidth < 768) {
                    maxWidthVal = maxWidth * 0.5;
                }
                var titleContainer = navbarBrand.querySelector(".titleContainer");
                titleContainer.style = "";
                var navSpan = titleContainer.firstElementChild;
                var actualWidth = $(navSpan).width();
                if (actualWidth + 26 >= maxWidthVal) {
                    actualWidth = maxWidthVal - 36;
                }
                titleContainer.style.width = (actualWidth + 5) + "px";
            } else {
                var navSpan = navbarBrand.firstElementChild;
                navSpan.style = "";
            }
        }
    }

    StickyDynamicMenu.init = function init(args) {
        return args.IsEditorEditing === true
            ? null
            : new StickyDynamicMenu(args.scope, args.showMoreItemsText, args.hideMoreItemsText);
    };

    return StickyDynamicMenu;
});

